<div class="row">
  <div class="col-12">
    <sb-card [loading]="loading">
      <div card-fit>
        <sb-wizard #wizard [hideTabs]="true">
          <sb-wizard-tab #tab1 titleText="{{ 'lang.wizard.tabs.generalSettings' | translate }}" icon="basicSettings"
                         [active]="true">
            <form [formGroup]="form" class="wizard__forms p-5">
              <h3 *ngIf="templateDatasetId" class="my-4">{{'lang.globals.templateDatasets.edit' | translate}}</h3>
              <h3 *ngIf="!templateDatasetId" class="my-4">{{'lang.globals.templateDatasets.create' | translate}}</h3>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group validateMe">
                    <label class="form-label" for="Title">{{'lang.globals.name' | translate}}<span class="red">*</span></label>
                    <input type="text" id="Title" class="form-control" formControlName="Name" sbAutofocus>
                    <span class="form-text text-muted">{{'lang.planningEdit.nameDescription' | translate}}</span>
                    <div *ngIf="Name.touched && Name.errors?.required"
                         class="alert alert-danger">{{'lang.planningEdit.nameWarning' | translate}}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group validateMe w-100">
                    <label class="form-label" for="Group">{{'lang.globals.templateGroup'|translate}}<span class="red">*</span></label>
                    <button *ngIf="permissionService.hasPermission(permissionService.Permission.template_group_list)"
                            (click)="selectGroup()"
                            id="Group"
                            class="btn btn-hover-primary w-100"
                            [ngClass]="getFilterSelectClass()">
                      <sb-icon icon="templates"></sb-icon>
                      {{getFilterText()}}
                    </button>
                  </div>
                </div>
              </div>
              <div class="wizard__footerActions">
                <a [sbRouterLink]="util.RoutingID.templateDatasets" class="btn btn-default btn-lg btn-wide">{{'lang.globals.cancel' | translate}}
                </a>
                <button *ngIf="!templateDatasetId" type="button" (click)="createTemplateDataset()" [disabled]="!(form.valid && templateGroup) || loading"
                           class="btn btn-success btn-wide btn-lg">{{'lang.globals.submit' | translate}}</button>
                <button type="button" *ngIf="templateDatasetId" (click)="updateTemplateDataset()"
                           [disabled]="!(form.valid && templateDataset && templateGroup)|| loading"
                           class="btn btn-success btn-wide btn-lg">{{'lang.globals.save' | translate}}</button>
              </div>
            </form>
          </sb-wizard-tab>
        </sb-wizard>

      </div>
    </sb-card>
  </div>
</div>
